import React, { createContext, memo, useEffect, useState } from "react";
import {
  calculateUpgradeCharge,
  checkOnlyDigitalTarrifSelected,
  convertNaNToZero,
  getTotalBuyPrice,
  getTotalSalePrice,
} from "../utils/helper";
import { clearAccessToken, markAuthReady } from "../services/tokenStore";
import { refreshAccessToken } from "../services/index";
import { getDefaultContractLengths } from "./Variable";

export const AppContext = createContext();

const AppProvider = (props) => {
  // Search Keys
  const [searchKeys, setSearchKeys] = useState({
    agentAllConnection: "",
  });
  // user data

  const [userData, setUserData] = useState(null);
  // when contract summary send

  const [sendType, setSendType] = useState({
    type: "add",
    id: null,
  });

  const [isBankDetailsVerified, setIsBankDetailsVerified] = useState(false);
  const [isContractAccepted, setIsContractAccepted] = useState(false);
  const [isSummarySend, setIsSummarySend] = useState(false);
  const [isBillingEmailSame, setIsBillingEmailSame] = useState(false);
  const [leadProposal, setLeadProposal] = useState({
    isConverted: false,
    data: null,
  });

  // Upfrontpayment collected
  const [isUpfrontPaymentCollected, setIsUpfrontPaymentCollected] =
    useState("");

  // Account Number

  const [accountNo, setAccountNo] = useState("");

  // Form note

  const [note, setNote] = useState("");
  const [allNotes, setAllNotes] = useState([]);

  // Dates

  const [contractEndDate, setContractEndDate] = useState(null);
  const [followUpDate, setFollowUpDate] = useState(null);

  // Debit Details

  const [isReqDebitDetail, setIsReqDebitDetail] = useState({
    yes: true,
    no: false,
  });

  // Dowload speed

  const [downloadSpeed, setDownloadSpeed] = useState({
    min: 0,
    max: 0,
  });
  // Upload speed

  const [uploadSpeed, setUploadSpeed] = useState({
    // min: 0.5,
    // max: 115,
    min: 0,
    max: 0,
  });

  // Form details

  const [generalInfo, setGeneralInfo] = useState({
    signupDate: new Date(),
    liveDate: null,
    agent: "",
    name: "",
    secondName: "",
    isAddCustomer: false,
    businessName: "",
    designation: "",
    title: "",
    address1: "",
    address2: "",
    email: "",
    town: "",
    city: "",
    postCode: "",
    billingEmail: "",
    businessType: "",
    mobileNo: "",
    eBilling: "",
    currentProvider: "",
  });

  // constract length
  const [contractLength, setContractLength] = useState(
    getDefaultContractLengths()
  );

  // true = show 12/18 Months too (legacy contracts without availableForNew: true)
  const [showAllContractLengths, setShowAllContractLengths] = useState(false);

  // Ebilling Address if billing selected to no

  const [eBillingAddress, setEbillingAddress] = useState({
    town: "",
    city: "",
    postCode: "",
    address1: "",
    address2: "",
  });

  // Platform upgrade charge not use now

  const [upgradeCharge, setUpgradeCharge] = useState([
    {
      title: "Install",
      isSelected: false,
      price: 60,
    },
    // {
    //   title: "SOGEA - £30",
    //   isSelected: false,
    //   price: 30,
    // },
    // {
    //   title: "SOGEA - FOC - £0 ",
    //   isSelected: false,
    //   price: 0,
    // },
    // {
    //   title: "3FTTP - £60",
    //   isSelected: false,
    //   price: 60,
    // },
    // {
    //   title: "FTTP - £30",
    //   isSelected: false,
    //   price: 30,
    // },
    // {
    //   title: "FTTP - FOC - £0",
    //   isSelected: false,
    //   price: 0,
    // },
    // {
    //   title: "Not required",
    //   isSelected: false,
    //   price: "Not required",
    // },
  ]);

  // Corderless

  const [corded, setCorded] = useState([
    {
      title: "Corded Phones",
      value: 0,
      isSelected: false,
    },
    {
      title: "Cordless Phones",
      value: 0,
      isSelected: false,
    },
  ]);

  // Debit details

  const [debitDetails, setDebitDetails] = useState({
    username: "",
    accountNumber: "",
    shortCode: "",
    address: "",
  });

  // cli box data

  const [cliData, setCliData] = useState([
    {
      mobileNo: "",
      cliNumber: true,
      line: 1,
      legacyTariff: {
        title: "Legacy",
        isSelected: false,
        type: "legacyTariff",
      },
      digitalTariff: {
        title: "Digital/NGN",
        isSelected: true,
        type: "digitalTariff",
      },
      additionalService: {
        title: "Additional  services",
        isSelected: false,
        type: "additionalService",
      },
      differentAddress: {
        title: "Different Address",
        isSelected: true,
        type: "differentAddress",
        value: "",
      },
      upgradeCharge: {
        title: "Install",
        isSelected: false,
        type: "upgradeCharge",
        salePrice: 60,
        buyPrice: 60,
        attachedValue: "",
        timePeriod: "",
        upPayment: true,
        isCollected: "",
        liveDate: null,
        isImmediate: true,
      },
      migration: {
        title: "Migration",
        isSelected: false,
        type: "migration",
        salePrice: 60,
        buyPrice: 60,
        attachedValue: "",
        timePeriod: "",
        upPayment: false,
        firstMonth: false,
        isCollected: "",
        liveDate: null,
        isImmediate: true,
      },
      transfer: {
        title: "Transfer",
        isSelected: false,
        type: "transfer",
        attachedValue: "",
        liveDate: null,
        isImmediate: true,
      },
      // lineValues: [
      //   {
      //     legacy: {
      //       value: "",
      //       salePrice: 0,
      //       buyPrice: 0,
      //       highPrice: 0,
      //       length12: 0,
      //       length18: 0,
      //       length24: 0,
      //       length36: 0,
      //       error: false,
      //       errorMessage: "",
      //       other: "",
      //     },
      //     legacyService1: { value: "", salePrice: 0, buyPrice: 0 },
      //     legacyService2: { value: "", salePrice: 0, buyPrice: 0 },
      //     legacyService3: { value: "", salePrice: 0, buyPrice: 0 },
      //     legacyService4: { value: "", salePrice: 0, buyPrice: 0 },
      //     ngnValue: { value: "", salePrice: 0, buyPrice: 0, other: null },
      //     ngnService1: { value: "", salePrice: 0, buyPrice: 0 },
      //     ngnService2: { value: "", salePrice: 0, buyPrice: 0 },
      //     ngnService3: { value: "", salePrice: 0, buyPrice: 0 },
      //     ngnService4: { value: "", salePrice: 0, buyPrice: 0 },
      //   },
      // ],
      lineValues: [
        {
          legacy: null,
          legacyService1: null,
          legacyService2: null,
          legacyService3: null,
          legacyService4: null,
          ngnValue: null,
          ngnService1: null,
          ngnService2: null,
          ngnService3: null,
          ngnService4: null,
        },
      ],
    },
  ]);

  // Selected router value

  const [routerValue, setRouterValue] = useState({
    value: 0,
    price: 0,
    costType: "oneOfCost", // 3/01/25 changes
    isUpgrade: false,
  });

  // Corded Phone

  const [cordedPhone, setSetCordedPhone] = useState({
    value: 0,
    price: 0,
    costType: "oneOfCost", // 3/01/25 changes
  });

  // Cordless phone

  const [cordedlessPhone, setCordlessPhone] = useState({
    value: 0,
    price: 0,
    costType: "oneOfCost", // 3/01/25 changes
  });

  // Add paper billing price when user say no to e billing

  const [paperBillingPrice, setPaperBillingPrice] = useState({
    value: "Paper Billing Charges",
    salePrice: 5.0,
    buyPrice: 5.0,
    highPrice: 5.0,
    length12: 2.0,
    length18: 2.0,
    length24: 2.0,
    length36: 2.0,
    error: false,
    errorMessage: "",
  });

  // Not is used

  const [sogeaUpgradeCharge, setSogeaUpgradeCharge] = useState({
    title: "Install",
    isSelected: false,
    salePrice: 60,
    buyPrice: 60,
  });

  // Other Equipments

  const [equipments, setEquipments] = useState({
    value: "",
    type: "",
    price: 0,
    costType: "oneOfCost", // 3/01/25 changes
    name: "",
  });

  // Add new state for other products
  const [otherProducts, setOtherProducts] = useState({
    selectedProducts: [],
    energy: {
      electricity: {
        isSelected: false,
        currentSupplier: "",
        date: "",
        meterNumber: "",
        monthlySpend: "",
        notesSelection: "",
        followUpDate: "",
      },
      gas: {
        isSelected: false,
        currentSupplier: "",
        date: "",
        meterNumber: "",
        monthlySpend: "",
        notesSelection: "",
        followUpDate: "",
      },
    },
    telecoms: {
      business: {
        isSelected: false,
        currentSupplier: "",
        date: "",
        meterNumber: "",
        monthlySpend: "",
        notesSelection: "",
        followUpDate: "",
      },
      residential: {
        isSelected: false,
        currentSupplier: "",
        date: "",
        meterNumber: "",
        monthlySpend: "",
        notesSelection: "",
        followUpDate: "",
      },
    },
    cardProcessing: {
      currentSupplier: "",
      date: "",
      meterNumber: "",
      monthlySpend: "",
      notesSelection: "",
      followUpDate: "",
    },
    mobile: {
      currentSupplier: "",
      date: "",
      meterNumber: "",
      monthlySpend: "",
      notesSelection: "",
      followUpDate: "",
    },
  });

  useEffect(() => {
    if (generalInfo.eBilling == "Yes") {
      setEbillingAddress({
        town: generalInfo.town,
        city: generalInfo.city,
        postCode: generalInfo.postCode,
        address1: generalInfo.address1,
        address2: generalInfo.address2,
      });
    } else {
      setEbillingAddress({
        town: "",
        city: "",
        postCode: "",
        address1: "",
        address2: "",
      });
    }
  }, [generalInfo.eBilling]);

  useEffect(() => {
    if (isBillingEmailSame) {
      setGeneralInfo((pre) => ({ ...pre, billingEmail: pre.email }));
    } else {
      setGeneralInfo((pre) => ({ ...pre, billingEmail: "" }));
    }
  }, [isBillingEmailSame, generalInfo.email]);

  useEffect(() => {
    const restoreSession = async () => {
      try {
        const raw = localStorage.getItem("user_data");
        if (!raw) return;

        const data = JSON.parse(raw);
        if (data.token) {
          delete data.token;
          localStorage.setItem("user_data", JSON.stringify(data));
        }
        setUserData(data);

        await refreshAccessToken();
      } catch (err) {
        clearAccessToken();
        localStorage.removeItem("user_data");
        setUserData(null);
      } finally {
        markAuthReady();
      }
    };

    restoreSession();
  }, []);

  const handleResetData = (finalReset) => {
    setCliData([
      {
        mobileNo: "",
        cliNumber: true,
        line: 1,
        legacyTariff: {
          title: "Legacy",
          isSelected: false,
          type: "legacyTariff",
        },
        digitalTariff: {
          title: "Digital/NGN",
          isSelected: true,
          type: "digitalTariff",
        },
        additionalService: {
          title: "Additional  services",
          isSelected: false,
          type: "additionalService",
        },
        differentAddress: {
          title: "Different Address",
          isSelected: true,
          type: "differentAddress",
          value: "",
        },
        upgradeCharge: {
          title: "Install",
          isSelected: false,
          type: "upgradeCharge",
          salePrice: 60,
          buyPrice: 60,
          attachedValue: "",
          timePeriod: "",
          upPayment: true,
          isCollected: "",
          liveDate: null,
          isImmediate: true,
        },
        migration: {
          title: "Migration",
          isSelected: false,
          type: "migration",
          salePrice: 60,
          buyPrice: 60,
          attachedValue: "",
          timePeriod: "",
          upPayment: false,
          firstMonth: false,
          isCollected: "",
          liveDate: null,
          isImmediate: true,
        },
        transfer: {
          title: "Transfer",
          isSelected: false,
          type: "transfer",
          attachedValue: "",
          liveDate: null,
          isImmediate: true,
        },
        // lineValues: [
        //   {
        //     legacy: {
        //       value: "",
        //       salePrice: 0,
        //       buyPrice: 0,
        //       highPrice: 0,
        //       length12: 0,
        //       length18: 0,
        //       length24: 0,
        //       length36: 0,
        //       error: false,
        //       errorMessage: "",
        //       other: "",
        //     },
        //     legacyService1: { value: "", salePrice: 0, buyPrice: 0 },
        //     legacyService2: { value: "", salePrice: 0, buyPrice: 0 },
        //     legacyService3: { value: "", salePrice: 0, buyPrice: 0 },
        //     legacyService4: { value: "", salePrice: 0, buyPrice: 0 },
        //     ngnValue: { value: "", salePrice: 0, buyPrice: 0, other: null },
        //     ngnService1: { value: "", salePrice: 0, buyPrice: 0 },
        //     ngnService2: { value: "", salePrice: 0, buyPrice: 0 },
        //     ngnService3: { value: "", salePrice: 0, buyPrice: 0 },
        //     ngnService4: { value: "", salePrice: 0, buyPrice: 0 },
        //   },
        // ],
        lineValues: [
          {
            legacy: null,
            legacyService1: null,
            legacyService2: null,
            legacyService3: null,
            legacyService4: null,
            ngnValue: null,
            ngnService1: null,
            ngnService2: null,
            ngnService3: null,
            ngnService4: null,
          },
        ],
      },
    ]);

    if (finalReset) {
      setDownloadSpeed({
        min: 0,
        max: 0,
      });
      setUploadSpeed({
        min: 0,
        max: 0,
      });
      setRouterValue({
        value: 0,
        price: 0,
        costType: "oneOfCost", // 3/01/25 changes
        isUpgrade: false,
      });
      setSetCordedPhone({
        value: 0,
        price: 0,
        costType: "oneOfCost", // 3/01/25 changes
      });
      setCordlessPhone({
        value: 0,
        price: 0,
        costType: "oneOfCost", // 3/01/25 changes
      });
      setEquipments({
        value: "",
        type: "",
        price: 0,
        costType: "oneOfCost", // 3/01/25 changes
        name: "",
      });
      setPaperBillingPrice({
        value: "Paper Billing Charges",
        salePrice: 5.0,
        buyPrice: 3.0,
        highPrice: 5.0,
        length12: 2.0,
        length18: 2.0,
        length24: 2.0,
        length36: 2.0,
        error: false,
        errorMessage: "",
      });
      setIsReqDebitDetail({
        yes: true,
        no: false,
      });
      setDebitDetails({
        username: "",
        accountNumber: "",
        shortCode: "",
        address: "",
      });
      setNote("");
      setAllNotes([]);
      setIsSummarySend(false);
      setIsContractAccepted(false);
      setContractEndDate(null);
      setFollowUpDate(null);
      setIsBankDetailsVerified(false);

      setContractLength(getDefaultContractLengths());
      setShowAllContractLengths(false);
      setGeneralInfo({
        signupDate: new Date(),
        liveDate: null,
        agent: "",
        name: "",
        secondName: "",
        isAddCustomer: false,
        businessName: "",
        designation: "",
        title: "",
        address1: "",
        address2: "",
        email: "",
        town: "",
        city: "",
        postCode: "",
        billingEmail: "",
        businessType: "",
        mobileNo: "",
        eBilling: "",
        currentProvider: "",
      });
      setIsBillingEmailSame(false);
      setSendType({
        type: "add",
        id: null,
      });

      setOtherProducts({
        selectedProducts: [],
        energy: {
          electricity: {
            isSelected: false,
            currentSupplier: "",
            date: "",
            meterNumber: "",
            monthlySpend: "",
            notesSelection: "",
            followUpDate: "",
          },
          gas: {
            isSelected: false,
            currentSupplier: "",
            date: "",
            meterNumber: "",
            monthlySpend: "",
            notesSelection: "",
            followUpDate: "",
          },
        },
        telecoms: {
          business: {
            isSelected: false,
            currentSupplier: "",
            date: "",
            meterNumber: "",
            monthlySpend: "",
            notesSelection: "",
            followUpDate: "",
          },
          residential: {
            isSelected: false,
            currentSupplier: "",
            date: "",
            meterNumber: "",
            monthlySpend: "",
            notesSelection: "",
            followUpDate: "",
          },
        },
        cardProcessing: {
          currentSupplier: "",
          date: "",
          meterNumber: "",
          monthlySpend: "",
          notesSelection: "",
          followUpDate: "",
        },
        mobile: {
          currentSupplier: "",
          date: "",
          meterNumber: "",
          monthlySpend: "",
          notesSelection: "",
          followUpDate: "",
        },
      });
    }
  };

  /**
   * Calculates the total revenue based on the provided data.
   *
   * @returns {number} - The total revenue rounded to two decimal places as number.
   */

  const calculateTotalRevenue = () => {
    let totalRevenue = 0;

    const totalSalePriceBox = getTotalSalePrice(cliData);
    totalRevenue += totalSalePriceBox;

    if (routerValue.costType === "monthly") {
      const routerPrice = routerValue.price;
      totalRevenue += convertNaNToZero(routerPrice);
    }

    if (cordedPhone.costType === "monthly") {
      const cordedPhonePrice = cordedPhone.price;
      totalRevenue += convertNaNToZero(cordedPhonePrice);
    }

    if (cordedlessPhone.costType === "monthly") {
      const cordedlessPhonePrice = cordedlessPhone.price;
      totalRevenue += convertNaNToZero(cordedlessPhonePrice);
    }

    if (equipments.costType === "monthly") {
      const extraEquipmentPrice = equipments.price;
      totalRevenue += convertNaNToZero(extraEquipmentPrice);
    }

    // const totalUpgradeChargeBox = calculateUpgradeCharge(cliData);
    // totalRevenue += convertNaNToZero(totalUpgradeChargeBox.salePrice);

    // 9/12/24 changes router charges not include in revenue
    // const routerPrice = routerValue.price;
    // totalRevenue += convertNaNToZero(routerPrice);

    // 9/12/24 changes corder phone charges not include in revenue
    // const cordedPhonePrice = cordedPhone.price;
    // totalRevenue += convertNaNToZero(cordedPhonePrice);

    // 9/12/24 changes cordless phone charges not include in revenue
    // const cordedlessPhonePrice = cordedlessPhone.price;
    // totalRevenue += convertNaNToZero(cordedlessPhonePrice);

    // not in used
    // if (sogeaUpgradeCharge.isSelected) {
    //   const upgradeCharge = sogeaUpgradeCharge.salePrice;
    //   totalRevenue += upgradeCharge;
    // }

    // if (generalInfo.eBilling === "No") {
    //   const totalParperBillingPrice = paperBillingPrice.salePrice;
    //   totalRevenue += convertNaNToZero(totalParperBillingPrice);
    // }

    // if (isReqDebitDetail.no) {
    //   const debitDetailPrice = 7;
    //   totalRevenue += debitDetailPrice;
    // }

    return totalRevenue.toFixed(2);
  };

  const calculateGrossProfit = () => {
    let totalProfit = 0;

    /**
     * Total Tarrifs (Legacy & Digital NGN) 
     * Total sale price - total buy price
     * Ex: For Basic broad band Sale Price is 29.99(default) or whatever users input
     *     Its minus with the buy price which is now 19.68
    
     *  getTotalSalePrice(cliData) This function calculates the total sale price for cli bix 
     *  getTotalBuyPrice(cliData)(cliData) This function calculates the total buy price for cli bix 
     * 
     */

    const totalConnectonPrice =
      getTotalSalePrice(cliData) - getTotalBuyPrice(cliData);
    totalProfit += totalConnectonPrice;

    /**
     * When router monthly is selected and the price is default (1 Router => 1.50 ). It will not affect the gross profit
     * But its goes up from its default price it add in Gross Profit with formula like (router price - 1.5) ===> (2 - 1.5 = 0.5)
     * But its goes below from its default price its directly minus the current Gross profit with input router price
     * 10.31 - 0.5 (user input)
     * This applies for all Router, Corded and Cordless
     */

    const isRouterMonthlySelected =
      routerValue.costType === "monthly" && routerValue.value > 0;

    const isCordedMonthlySelected =
      cordedPhone.costType === "monthly" && cordedPhone.value > 0;

    const isCordedlessMonthlySelected =
      cordedlessPhone.costType === "monthly" && cordedlessPhone.value > 0;

    const isEquipmentMonthlySelected =
      equipments.costType === "monthly" &&
      equipments.value &&
      equipments.price > 0;

    if (isRouterMonthlySelected) {
      if (routerValue.price > routerValue.value * 1.5) {
        const routerPrice = routerValue.price - routerValue.value * 1.5;
        totalProfit += convertNaNToZero(routerPrice);
      }
      if (routerValue.price < routerValue.value * 1.5) {
        const routerPrice = routerValue.value * 1.5 - routerValue.price;
        totalProfit -= convertNaNToZero(routerPrice);
      }
    }

    if (isCordedMonthlySelected) {
      if (cordedPhone.price > cordedPhone.value * 1.5) {
        const cordedPrice = cordedPhone.price - cordedPhone.value * 1.5;
        totalProfit += convertNaNToZero(cordedPrice);
      }
      if (cordedPhone.price < cordedPhone.value * 1.5) {
        const cordedPrice = cordedPhone.value * 1.5 - cordedPhone.price;
        totalProfit -= convertNaNToZero(cordedPrice);
      }
    }

    if (isCordedlessMonthlySelected) {
      if (cordedlessPhone.price > cordedlessPhone.value * 1.5) {
        const cordedlessPrice =
          cordedlessPhone.price - cordedlessPhone.value * 1.5;
        totalProfit += convertNaNToZero(cordedlessPrice);
      }
      if (cordedlessPhone.price < cordedlessPhone.value * 1.5) {
        const cordedlessPrice =
          cordedlessPhone.value * 1.5 - cordedlessPhone.price;
        totalProfit -= convertNaNToZero(cordedlessPrice);
      }
    }

    if (isEquipmentMonthlySelected) {
      const equipmentPrice = equipments.price;
      totalProfit += convertNaNToZero(equipmentPrice);
    }

    // if (generalInfo.eBilling === "No") {
    //   const totalParperBillingPrice =
    //     paperBillingPrice.salePrice - paperBillingPrice.buyPrice;
    //   totalProfit += convertNaNToZero(totalParperBillingPrice);
    // }

    // if (isReqDebitDetail.no) {
    //   const debitDetailPrice = 7;
    //   totalProfit += debitDetailPrice;
    // }

    return totalProfit.toFixed(2);
  };

  /**
   * Calculate the total one of cost price the price which add ones only
   *
   * @returns {number} - The total revenue rounded to two decimal places as number
   */

  const calculateOneOfCost = () => {
    let oneOfCost = 0;
    const totalUpgradeChargeBox = calculateUpgradeCharge(cliData);
    oneOfCost += convertNaNToZero(totalUpgradeChargeBox.salePrice);

    if (routerValue.costType === "oneOfCost") {
      const routerPrice = routerValue.price;
      oneOfCost += convertNaNToZero(routerPrice);
    }

    // if (!checkOnlyDigitalTarrifSelected(cliData)) {// }
    if (cordedPhone.costType === "oneOfCost") {
      const cordedPhonePrice = cordedPhone.price;
      oneOfCost += convertNaNToZero(cordedPhonePrice);
    }

    if (cordedlessPhone.costType === "oneOfCost") {
      const cordedlessPhonePrice = cordedlessPhone.price;
      oneOfCost += convertNaNToZero(cordedlessPhonePrice);
    }

    if (equipments.costType === "oneOfCost") {
      const extraEquipmentPrice = equipments.price;
      oneOfCost += convertNaNToZero(extraEquipmentPrice);
    }

    return oneOfCost.toFixed(2);
  };

  const calculateOneOfCostProfit = () => {
    let oneOfCostProfit = 0;
    const length = contractLength.find((x) => x.isSelected === true)?.value;

    /**
     * SALE PRICE = 60
     * BUY PRICE = 60
     * INPUT PRICE = USER INPUT
     * When install and migration is selected to any cli box
     * If its go above to sale price (sale price - user input price) / 12 as per requirment
     * If its go below to sale price (sale price - user input price) / 12 as per requirment
     */

    const totalUpgradeChargeBox = calculateUpgradeCharge(cliData);
    const upCharges =
      (totalUpgradeChargeBox.salePrice - totalUpgradeChargeBox.whole) / 12;
    oneOfCostProfit += convertNaNToZero(upCharges);

    const isRouterOneOfCostSelected =
      routerValue.costType === "oneOfCost" && routerValue.value > 0;
    const isCordedOneOfCostSelected =
      cordedPhone.costType === "oneOfCost" && cordedPhone.value > 0;
    const isCordlessOneOfCostSelected =
      cordedlessPhone.costType === "oneOfCost" && cordedlessPhone.value > 0;

    if (isRouterOneOfCostSelected) {
      if (routerValue.price > routerValue.value * 20) {
        const routerPrice = (routerValue.price - routerValue.value * 20) / 12;
        oneOfCostProfit += convertNaNToZero(routerPrice);
      }
      if (routerValue.price < routerValue.value * 20) {
        const routerPrice =
          (routerValue.price - routerValue.value * 20) / length;
        oneOfCostProfit += convertNaNToZero(routerPrice);
      }
    }

    if (isCordedOneOfCostSelected) {
      if (cordedPhone.price > cordedPhone.value * 20) {
        const cordedPrice = (cordedPhone.price - cordedPhone.value * 20) / 12;
        oneOfCostProfit += convertNaNToZero(cordedPrice);
      }
      if (cordedPhone.price < cordedPhone.value * 20) {
        const cordedPrice =
          (cordedPhone.price - cordedPhone.value * 20) / length;
        oneOfCostProfit += convertNaNToZero(cordedPrice);
      }
    }

    if (isCordlessOneOfCostSelected) {
      if (cordedlessPhone.price > cordedlessPhone.value * 30) {
        const cordedlessPrice =
          (cordedlessPhone.price - cordedlessPhone.value * 30) / 12;
        oneOfCostProfit += convertNaNToZero(cordedlessPrice);
      }
      if (cordedlessPhone.price < cordedlessPhone.value * 30) {
        const cordedlessPrice =
          (cordedlessPhone.price - cordedlessPhone.value * 30) / length;
        oneOfCostProfit += convertNaNToZero(cordedlessPrice);
      }
    }

    return oneOfCostProfit.toFixed(2);
  };

  return (
    <AppContext.Provider
      value={{
        userData,
        setUserData,
        generalInfo,
        setGeneralInfo,
        isSummarySend,
        setIsSummarySend,
        isContractAccepted,
        setIsContractAccepted,
        isReqDebitDetail,
        setIsReqDebitDetail,
        downloadSpeed,
        setDownloadSpeed,
        uploadSpeed,
        setUploadSpeed,
        contractLength,
        setContractLength,
        showAllContractLengths,
        setShowAllContractLengths,
        eBillingAddress,
        setEbillingAddress,
        upgradeCharge,
        setUpgradeCharge,
        corded,
        setCorded,
        debitDetails,
        setDebitDetails,
        note,
        setNote,
        cliData,
        setCliData,
        routerValue,
        setRouterValue,
        paperBillingPrice,
        setPaperBillingPrice,
        sogeaUpgradeCharge,
        setSogeaUpgradeCharge,
        calculateTotalRevenue,
        calculateGrossProfit,
        calculateOneOfCost,
        calculateOneOfCostProfit,
        handleResetData,
        cordedPhone,
        setSetCordedPhone,
        cordedlessPhone,
        setCordlessPhone,
        isBillingEmailSame,
        setIsBillingEmailSame,
        equipments,
        setEquipments,
        sendType,
        setSendType,
        leadProposal,
        setLeadProposal,
        otherProducts,
        setOtherProducts,
        allNotes,
        setAllNotes,
        searchKeys,
        setSearchKeys,
        accountNo,
        setAccountNo,
        contractEndDate,
        setContractEndDate,
        followUpDate,
        setFollowUpDate,
        isUpfrontPaymentCollected,
        setIsUpfrontPaymentCollected,
        isBankDetailsVerified,
        setIsBankDetailsVerified,
      }}
    >
      {props.children}
    </AppContext.Provider>
  );
};

export default memo(AppProvider);
